module.exports = __webpack_public_path__ + "img/行业解决方案_城市排水03.ed5700f1.png";